import { Person } from '../Models/person';

export const sortPeople: (people: Person[]) => Person[] = (people) => {
    let sortedPeople = people.sort((a, b) => {
        let nameA = `${a.lastName} ${a.firstName}`;
        let nameB = `${b.lastName} ${b.firstName}`;
        return nameA.localeCompare(nameB);
    });

    return sortedPeople;
};
